import type { ReactElement } from "react";
import { LoadingBar } from "./LoadingBar";
import { LoadingChoropleth } from "./LoadingChoropleth";
import { LoadingHeatmap } from "./LoadingHeatmap";
import { LoadingLine } from "./LoadingLine";
import { LoadingPie } from "./LoadingPie";
import { LoadingStat } from "./LoadingStat";
import { LoadingTable } from "./LoadingTable";

type ChartType =
  | "stat"
  | "pie"
  | "bar"
  | "line"
  | "table"
  | "choropleth"
  | "heatmap";

interface LoadingChartComponentProps {
  className?: string;
  type: ChartType;
}

interface LoadingChildProps {
  baseContainerClasses: string;
  className?: string;
}

type LoadingChildComponent = (props: LoadingChildProps) => ReactElement;

const LoadingComponentMapping: Record<ChartType, LoadingChildComponent> = {
  stat: LoadingStat,
  pie: LoadingPie,
  bar: LoadingBar,
  line: LoadingLine,
  table: LoadingTable,
  choropleth: LoadingChoropleth,
  heatmap: LoadingHeatmap,
};

const DefaultLoadingComponent: LoadingChildComponent = LoadingStat;

export const LoadingChartComponent = ({
  className,
  type,
}: LoadingChartComponentProps): ReactElement => {
  const baseContainerClasses =
    "border-primary flex w-full flex-col rounded-xl border p-6";

  const Component = LoadingComponentMapping[type] || DefaultLoadingComponent;

  return (
    <Component
      className={className}
      baseContainerClasses={baseContainerClasses}
    />
  );
};

LoadingChartComponent.displayName = "LoadingChartComponent";
